/**
 * Face Verification Mock Page
 *
 * A simple wrapper page for the mock FaceVerificationMock component.
 * This page is rendered at the /face-liveness-mock route.
 */

import { FaceVerificationMock } from "../components/faceVerificationMock/FaceVerificationMock";

export function FaceVerificationMockPage() {
  return <FaceVerificationMock />;
}
